import { Clock, XCircle } from "lucide-react";
import { problem } from "../content/site";
import { Container, Reveal, Stagger, StaggerItem } from "./ui";

export default function ProblemSection() {
  return (
    <section className="bg-[var(--color-bg-soft)] py-20 sm:py-28">
      <Container>
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl leading-[1.1] font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
            {problem.headline}
          </h2>
        </Reveal>

        <Stagger className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-5">
          {problem.steps.map((step, idx) => {
            const isLast = idx === problem.steps.length - 1;
            return (
              <StaggerItem key={step}>
                <div
                  className={`flex h-full flex-col items-center justify-center gap-3 rounded-2xl border p-6 text-center transition-colors ${
                    isLast
                      ? "border-primary/30 bg-[var(--color-bg-light-orange)]"
                      : "border-navy/8 bg-white"
                  }`}
                >
                  {isLast ? (
                    <XCircle size={28} className="text-primary" />
                  ) : (
                    <Clock size={28} className="text-navy/30" />
                  )}
                  <span
                    className={`text-lg font-extrabold sm:text-xl ${
                      isLast ? "text-primary" : "text-navy"
                    }`}
                  >
                    {step}
                  </span>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>

        <Reveal delay={0.15} className="mx-auto mt-14 max-w-xl text-center">
          <p className="text-xl font-bold text-navy sm:text-2xl">{problem.line1}</p>
          <p className="mt-1 text-xl font-bold text-navy/50 sm:text-2xl">{problem.line2}</p>
          <div className="mx-auto mt-8 h-px w-16 bg-navy/10" />
          <p className="mt-8 text-2xl font-extrabold text-primary sm:text-3xl">
            {problem.resolution}
          </p>
        </Reveal>
      </Container>
    </section>
  );
}
